export const COLUMNS = [
  "checkbox",
  "name",
  "sharesOwned",
  "sentiment",
  "bestQuestion",
];
